(() => {
  const root = document.getElementById('RavellaMain');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- SCROLL REVEAL ---------- */
  const revealTargets = root.querySelectorAll('[data-reveal], [data-reveal-stagger]');
  if (revealTargets.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach((el) => el.classList.add('in-view'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );
      revealTargets.forEach((el) => revealObserver.observe(el));
    }
  }

  /* ---------- IMAGE FADE-IN ---------- */
  if (!reduceMotion) {
    root.querySelectorAll('[data-fade-img] img, .product-media img, .ravella-pdp-media img').forEach((img) => {
      const target = img.matches('[data-fade-img]') ? img : img.closest('[data-fade-img]') || img;
      if (img.complete && img.naturalWidth) return; // already loaded, skip the fade
      target.classList.add('is-loading');
      const clear = () => target.classList.remove('is-loading');
      img.addEventListener('load', clear, { once: true });
      img.addEventListener('error', clear, { once: true });
    });
  }

  /* ---------- ANIMATED ACCORDIONS ---------- */
  class RavellaAccordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.ravella-accordion-copy');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      if (this.summary) this.summary.addEventListener('click', (event) => this.onClick(event));
    }

    onClick(event) {
      event.preventDefault();
      if (reduceMotion) {
        this.el.open = !this.el.open;
        return;
      }
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(.65,0,.35,1)' }
      );
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + (this.content ? this.content.offsetHeight : 0)}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(.65,0,.35,1)' }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';
    }
  }

  root.querySelectorAll('.ravella-accordions details').forEach((el) => new RavellaAccordion(el));

  root.querySelectorAll('[data-ravella-product]').forEach((root) => {
    const select = root.querySelector('[data-ravella-variant-select]');
    const price = root.querySelector('[data-ravella-price]');
    const addButton = root.querySelector('[data-ravella-add]');
    const form = root.querySelector('.ravella-product-form');

    const gallery = root.querySelector('[data-ravella-gallery]');
    if (gallery) {
      const mainImage = gallery.querySelector('.ravella-pdp-media img');
      const thumbs = gallery.querySelectorAll('[data-ravella-thumb]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage || thumb.classList.contains('is-active')) return;
          const nextSrc = thumb.dataset.full;
          const nextAlt = thumb.dataset.alt;
          thumbs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');

          const swap = () => {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = nextSrc;
            if (nextAlt) mainImage.alt = nextAlt;
            if (!reduceMotion) {
              requestAnimationFrame(() => mainImage.classList.remove('is-switching'));
            } else {
              mainImage.classList.remove('is-switching');
            }
          };

          if (reduceMotion) {
            swap();
          } else {
            mainImage.classList.add('is-switching');
            window.setTimeout(swap, 180);
          }
        });
      });
    }

    if (price) {
      price.addEventListener('animationend', () => price.classList.remove('is-updated'));
    }

    if (select && price) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (option?.dataset?.price) price.textContent = option.dataset.price;

        if (!reduceMotion) {
          price.classList.remove('is-updated');
          // eslint-disable-next-line no-void
          void price.offsetWidth;
          price.classList.add('is-updated');
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    }

    if (form && addButton) {
      form.addEventListener('submit', () => {
        if (addButton.disabled) return;
        addButton.classList.add('is-adding');
        addButton.dataset.originalText = addButton.textContent;
        addButton.textContent = 'ADDING…';
      });
    }
  });
})();
